import { gql } from "@apollo/client";

/**
 * Creates or replaces the network scan documented on a node (IBM-1039). The
 * response updates the node's own scan in the cache; the effective scans of
 * systems/assets below are separate cache entities and are refetched by the
 * caller (see NETWORK_SCAN_REFETCH_QUERIES).
 */
export const DocumentNetworkScan = gql`
    mutation DocumentNetworkScan($installedBaseNodeId: ID!, $input: DocumentNetworkScanInput!) {
        documentNetworkScan(installedBaseNodeId: $installedBaseNodeId, input: $input) {
            id
            canDocumentNetworkScan
            networkScan {
                state
                scanDate
                userName
            }
        }
    }
`;
